<template>
  <DxPopup
    :visible="popupConfig.visible"
    :drag-enabled="true"
    :close-on-outside-click="false"
    :show-title="true"
    :width="'90%'"
    :height="'80%'"
    :title="'Sales Order Selection'"
    :showCloseButton="false"
    :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-work-order-so-lines' }"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />
    <div class="css-v2 transaction-list">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
        :rightContainerWidth="250"
      >
        <template #leftContent>
          <dx-data-grid
            v-if="popupConfig.visible"
            :columnChooser="{
              enabled: false,
            }"
            :pager="{ visible: false }"
            :columns="getSalesGridColumns"
            :data-source="dataSourceConfig"
            :row-alternation-enabled="true"
            :selection="{
              mode: 'multiple',
            }"
            :height="getGridHeight"
            :width="'100%'"
            @toolbar-preparing="onToolbarPreparing($event)"
            @selection-changed="onSelectionChanged"
            @content-ready="onContentReady"
            :ref="'so-list-grid'"
          >
            <DxSearchPanel :visible="false" />
            <template #Record="{ data }">
              <GcRecord
                :data="data"
                :primary="data.column['cellTemplateRecord']['primary']"
                :secondary="data.column['cellTemplateRecord']['secondary']"
              />
            </template>

            <template #Decimal="{ data }">
              <GcDecimal :dataValue="data" :format="data.column.format" />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <gc-filter-panel
            :toolbarVisible="true"
            :toolbar="filterToolbar"
            :formItemData="filterFormItems"
            :setGridPanelFilter="setGridPanelFilter"
            :gridFoolter="false"
            :showLoading="showLoading"
            :from="'model'"
            :isNormal="false"
            :persistenceKey="undefined"
            :key="'fp-call-schedule'"
            :overWriteClear="true"
            :ref="'gc-filter-panel'"
            :heightAdjustment="filterHeightAdjustment"
          >
          </gc-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>

    <!-- <div class="footer link-an-item-popup-footer">
      <DxButton
        text="Cancel"
        type="default"
        styling-mode="contained"
        class="cancel-btn"
        @click="popupHidden"
      />
      <DxButton
        text="Select"
        type="success"
        styling-mode="contained"
        class="cancel-btn"
        @click="addSoLines"
      />
    </div> -->
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";

export default {
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    addSelectedSoLines: {
      type: Function,
      default: () => {},
    },
    preSelectedItems: {
      type: Array,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin, DataGridMixin],
  data() {
    return {
      showLeftContainer: true,
      showRightContainer: true,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
      },
      selectedItems: [],
      initiateDataLoading: false,
      defaultFilterValues: [],
      setGridHeight: "auto",
      filterHeightAdjustment: 0,
      productCategory3Filter: [],
    };
  },
  beforeMount() {
    if (this.popupConfig.ProductInfo) {
      if (this.popupConfig.ProductInfo["ProductCategory3Code"])
        this.productCategory3Filter.push(
          this.popupConfig.ProductInfo["ProductCategory3Code"]
        );
      else this.productCategory3Filter = [];
    } else this.productCategory3Filter = [];
  },
  async mounted() {
    this.initiateDataLoading =
      (await this.filterFormItems.filter((x) => x.filterDefaultValue).length) ==
      0
        ? true
        : false;
  },
  async created() {
    setTimeout(() => {
      this.setGridHeight = this.filterHeightAdjustment =
        document.querySelectorAll(
          ".gc-popup-work-order-so-lines .dx-popup-content"
        )[0].clientHeight - 20;
    }, 1);
  },
  computed: {
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "Select",
            stylingMode: "contained",
            type: "success",
            onClick: this.addSoLines,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.popupHidden,
          },
        },
      ];
    },

    getGridHeight() {
      return this.setGridHeight;
    },

    popupVisible() {
      return this.setVisible ? true : false;
    },

    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "left",
          width: 30,
          minWidth: 30,
        },
        {
          caption: "Sales Order",
          dataField: "SalesOrderCode",
          width: ColumnWidth.SalesOrderNumber.width - 15,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth - 15,
          alignment: "left",
        },
        {
          screenField: "Customer",
          allowSorting: true,
        },
        {
          screenField: "LineComment",
          caption: "Line #",
          dataField: "SalesOrderLine",
          width: ColumnWidth.LineInfo.width - 20,
          minWidth: ColumnWidth.LineInfo.minWidth - 20,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          dataField: "ShipDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "Product",
          caption: "Product",
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "SalesUMQuantity",
          caption: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "SalesUM",
          caption: "Sales UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQuantity",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
      ]);
    },

    dataSourceConfig() {
      if (this.initiateDataLoading) {
        return this.originalDataSourceConfig;
      } else {
        return [];
      }
    },
    originalDataSourceConfig() {
      return SalesOrderService.dataSourceConfig(
        "api/WorkOrderSalesOrderDetailLineList",
        {
          key: ["SalesOrderCode", "SalesOrderLine"],
        }
      );
    },

    /**
     * Retun filter panel form items
     * filterIndex field does have an impact , because we directly inject the fields in to the filter panel.
     * since it's a direct inject, field order is the order we define it. - SD
     */
    filterFormItems() {
      return [
        {
          screenField: "Code",
          filterLabel: "Sales Order",
          filterDataField: "SalesOrderCode",
          type: "Integer",
        },
        {
          screenField: "ProductAcct",
          filterDataField: "ProductCode",
          filterLabel: "Product",
          filterIndex: 18,
        },
        {
          screenField: "Customer",
          filterIndex: 6,
        },
        {
          screenField: "ShipDate",
          filterIndex: 2,
        },
        {
          screenField: "ReportShipMonthYear",
          filterIndex: 3,
          filterOperators: true,
          filterDefaultValue: "CurrentFiscalMonth",
          cellTemplate: "custom-cell-template",
          customCellDisplayField: "MonthDisplay",
        },
        {
          screenField: "Branch",
          filterIndex: 5,
          filterDefaultValue: ["01"],
        },
        {
          screenField: "Market",
          filterIndex: 12,
          filterDataField: "MarketCode",
          visible: false,
        },

        {
          screenField: "Region",
          filterIndex: 13,
          filterDataField: "RegionCode",
          visible: false,
        },

        {
          screenField: "SubRegion",
          filterIndex: 14,
          filterDataField: "SubregionCode",
        },
        {
          screenField: "ProductCategory1",
          visible: false,
          filterIndex: 19,
        },
        {
          screenField: "ProductCategory2",
          filterIndex: 20,
          visible: false,
        },
        {
          screenField: "ProductCategory3",
          filterIndex: 21,
          visible: false,
          filterDefaultValue:
            this.productCategory3Filter.length > 0
              ? this.productCategory3Filter
              : undefined,
        },
        {
          screenField: "ProductCategory4",
          filterIndex: 22,
          visible: false,
        },
        {
          screenField: "Attribute01Description",
          filterIndex: 23,
          filterDataField: "Attribute1Code",
        },
        {
          screenField: "Attribute02Description",
          filterIndex: 24,
          visible: false,
        },
        {
          screenField: "Attribute03Description",
          filterIndex: 25,
          visible: false,
        },
        {
          screenField: "Attribute04Description",
          filterIndex: 26,
          visible: false,
        },
        {
          screenField: "Attribute05Description",
          filterIndex: 27,
          visible: false,
        },
        {
          screenField: "Attribute06Description",
          filterIndex: 28,
          visible: false,
        },
        {
          screenField: "CustPO",
          filterIndex: 42,
          type: "Text",
        },
      ];
    },
  },
  methods: {
    popupHidden() {
      this.popupConfig.visible = false;
    },

    /**
     * Filter Panel values
     * @param e
     * @param valueChanged
     */

    // eslint-disable-next-line no-unused-vars
    setGridPanelFilter(e, valueChanged) {
      let dataGrid = this.$refs["so-list-grid"].instance;

      if (
        e.length === 0 &&
        valueChanged &&
        this.defaultFilterValues.length > 0
      ) {
        dataGrid.filter(this.defaultFilterValues);
        dataGrid.refresh(true);
      } else {
        if (this.initiateDataLoading == false) {
          dataGrid.option("dataSource", this.originalDataSourceConfig);
          this.initiateDataLoading = true;
          if (e.length > 0) this.defaultFilterValues = [...e];
        }

        if (dataGrid) {
          if (e.length > 0) dataGrid.filter(e);
          else dataGrid.clearFilter();

          dataGrid.refresh(true);
        }
      }
    },

    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: "filter",
          elementAttr: { id: "filter-btn" },
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            this.$logger.debug("item ", item);
            item.classList.add("dx-state-invisible");

            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
          },
          visible: !this.showRightContainer,
        },
      });
    },

    /**
     * on data grid line selected
     */
    onSelectionChanged(e) {
      this.selectedItems = e.selectedRowsData;
    },

    onContentReady(e) {
      if (this.preSelectedItems.length > 0) {
        let grid = e.component;
        if (grid) {
          let IDs = [];
          this.preSelectedItems.forEach((element) => {
            IDs.push({
              SalesOrderCode: element.SalesOrderCode,
              SalesOrderLine: element.SalesOrderLine,
            });
          });

          grid.selectRows(IDs, true);
        }
      }

      this.addGridNoResults(e, undefined);
    },

    addSoLines() {
      this.addSelectedSoLines(this.selectedItems);
      this.popupConfig.visible = false;
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-so-lines {
  .footer {
    .dx-button:first-child {
      margin-right: 12px;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .advance-filter-panel .dx-form {
    padding-bottom: 10px !important;
  }
}
</style>